export default {
    'common': {
        'save': 'Save',
        'delete': 'Delete',
        'dismiss': 'Dismiss',
        'dismissAll': 'Dismiss All',
        'enable': 'Enable',
        'disable': 'Disable',
        'remove': 'Remove',
        'cancel': 'Cancel'
    },
    'list': {
        'remember': 'Remember',
        'referenceFilterTooltip': 'Remove automatic list filtering',
        'restoreSettings': 'Restore List to Default',
        'template': 'Download {{ listTitle }} Template',
    },
    'listExport': {
        'header': 'Export {{ listTitle }}',
        'columns': 'Columns',
        'allColumns': 'All',
        'visibleColumns': 'Visible Only',
        'requiredColumnsForImport': 'Required for Import',
        'rows': 'Rows',
        'allRows': 'All Pages',
        'visibleRows': 'Current Page',
        'headersOnly': 'Headers Only',
        'format': 'Format',
        'delimiter': 'Delimiter',
        'comma': 'Comma',
        'semicolon': 'Semicolon',
        'cancel': '$t(common.cancel)',
        'export': 'Export'
    },
    'listImport': {
        'header': 'Import {{ listTitle }}',
        'uploadFile': 'Select File',
        'partialImport': 'Partial Import',
        'cancel': '$t(common.cancel)',
        'import': 'Import',
    },
    'pinFilter': {
        'enable': '$t(common.enable)',
        'disable': '$t(common.disable)',
        'remove': '$t(common.remove)',
        'makeGlobal': 'Make Global'
    },
    'userMessage': {
        'dismissAll': '$t(common.dismissAll)'
    },
    'notificationCenter': {
        'noNewNotifications': 'No new notifications',
        'dismissAll': '$t(common.dismissAll)',
    },
    'fieldLabel': {
        'createdBy': 'Created by',
        'createdDate': 'Created at',
        'changedBy': 'Changed by',
        'changedDate': 'Changed at',
        'id': 'ID',
        'version': 'Version',
    },
    'richTextEditor': {
        'expand': 'Expand',
        'collapse': 'Collapse',
    },
    'appBar': {
        'openMenu': 'Open main menu',
        'closeMenu': 'Close main menu',
    }
};
//# sourceMappingURL=en.js.map